import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  standalone: true,
  imports: [NgClass, AngularSvgIconModule],
})
export class StarRatingComponent {
  @Input() data: any = 0;
  @Input() size: 'sm' | 'md' | 'lg' = 'sm';
  @Input() type: 'fill' | 'outline' = 'fill';
}
